import {
  serverStatusGetPsdData,
  serverStatusGetYwyStatus
} from '@/api/api'

import { EventBus } from '@/event_bus.js'

const state = {
  needYwyUpdateStatus: false,
  needPsdUpdateStatus: false,
  ywyUpdateStatus: null,
  psdUpdateStatus: null
}

const getters = {
  needYwyUpdateStatus: state => state.needYwyUpdateStatus,
  needPsdUpdateStatus: state => state.needPsdUpdateStatus,
  ywyUpdateStatus: state => state.ywyUpdateStatus,
  psdUpdateStatus: state => state.psdUpdateStatus
}

const actions = {
  setNeedYwyUpdateStatus ({ commit, getters, dispatch }, data) {
    let goTimeout = !getters.needYwyUpdateStatus && data
    commit('setNeedYwyUpdateStatus', data)
    if (goTimeout) {
      dispatch('timeoutLoadYwyStatus')
    }
  },
  setNeedPsdUpdateStatus ({ commit, getters, dispatch }, data) {
    let goTimeout = !getters.needPsdUpdateStatus && data
    commit('setNeedPsdUpdateStatus', data)
    if (goTimeout) {
      dispatch('timeoutLoadPsdStatus')
    }
  },
  setYwyUpdateStatus ({ commit, getters, dispatch }, data) {
    if (getters.ywyUpdateStatus && getters.ywyUpdateStatus.interfaceDate && data && data.interfaceSwitch === 'on' && data.interfaceDate && getters.ywyUpdateStatus.interfaceDate !== data.interfaceDate) {
      EventBus.$emit('ywy-status-update')
      dispatch('showNoticeMsg', {type: 'success', title: '系统提示', message: '液位仪数据已更新，相关数据正在刷新！'})
    }
    commit('setYwyUpdateStatus', data)
  },
  setPsdUpdateStatus ({ commit, getters, dispatch }, data) {
    if (getters.psdUpdateStatus && getters.psdUpdateStatus.interfaceDate && data && data.interfaceSwitch === 'on' && data.interfaceDate && getters.psdUpdateStatus.interfaceDate !== data.interfaceDate) {
      EventBus.$emit('psd-status-update')
      dispatch('showNoticeMsg', {type: 'success', title: '系统提示', message: '配送单数据已更新，相关数据正在刷新！'})
    }
    commit('setPsdUpdateStatus', data)
  },
  timeoutLoadPsdStatus ({ dispatch, getters }) {
    if (getters.needPsdUpdateStatus) {
      serverStatusGetPsdData().then((data) => {
        dispatch('setPsdUpdateStatus', data)
      })
      setTimeout(() => {
        dispatch('timeoutLoadPsdStatus')
      }, 30000)
    }
  },
  timeoutLoadYwyStatus ({ dispatch, getters }) {
    if (getters.needYwyUpdateStatus) {
      serverStatusGetYwyStatus().then((data) => {
        dispatch('setYwyUpdateStatus', data)
      })
      setTimeout(() => {
        dispatch('timeoutLoadYwyStatus')
      }, 30000)
    }
  }
}

const mutations = {
  setNeedYwyUpdateStatus (state, data) {
    state.needYwyUpdateStatus = data
  },
  setNeedPsdUpdateStatus (state, data) {
    state.needPsdUpdateStatus = data
  },
  setYwyUpdateStatus (state, data) {
    state.ywyUpdateStatus = data
  },
  setPsdUpdateStatus (state, data) {
    state.psdUpdateStatus = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/update_status.js